import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";
const getLogoTitlesForClient = (client) => {
  switch (client) {
    case "ffh":
      return {
        env: "prod",
        main: "FFH Fantasy",
        tagline: "Gaming Hub",
      };
    case "ffhdev":
      return {
        env: "dev",
        main: "FFH Fantasy",
        tagline: "Gaming Hub",
      };
    case "betsson":
      return {
        env: "prod",
        main: "Betsson",
        tagline: "Gaming",
      };
    case "betssondev":
      return {
        env: "dev",
        main: "Betsson",
        tagline: "Gaming",
      };
    case "ewings":
      return {
        env: "prod",
        main: "Ewings",
        tagline: "Good Gaming",
      };
    case "ewingsdev":
      return {
        env: "dev",
        main: "Ewings",
        tagline: "Good Gaming",
      };
    case "nhldev":
      return {
        env: "dev",
        main: "NHL",
        tagline: "Fantasy Stars",
      };
      case "bet365dev":
        return {
          env: "dev",
          main: "Bet365",
          tagline: "Ultimate Fan",
        };
      case "bet365":
        return {
          env: "prod",
          main: "Bet365",
          tagline: "Ultimate Fan",
        };
      case "ncaafdev":
        return {
          env: "dev",
          main: "NCAAF",
          tagline: "Fantasy Stars",
        };
      case "ncaaf":
        return {
          env: "prod",
          main: "NCAAF",
          tagline: "Fantasy Stars",
        };
    default:
      return {
        env: "prod",
        main: "NHL",
        tagline: "Fantasy Stars",
      };
  }
};
const clientName = process.env.REACT_APP_CLIENT_NAME || "";
const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {

  if (!clientName || clientName.trim() === "") {
    return null;
  }

  const logoTitles = getLogoTitlesForClient(clientName.toLowerCase());

  const logoContainerStyles = {
    textAlign: "center",
    lineHeight: 1,
    padding: "1.5rem 1.75rem 0.5rem 1.75rem",
    background: "rgba(255, 255, 255, 0.02)",
    border: "2px solid rgba(255, 255, 255, 0.05)",
    display: "inline-block",
    position: "relative",
    overflow: "visible",
    ...sx,
  };

  const logoTextStyles = {
    fontFamily: "'Trebuchet MS', ui-sans-serif, system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 900,
    fontSize: "1.1rem",
    color: "#7ec373",
    transform: "skewX(-3deg)",
    display: "block",
    whiteSpace: "nowrap",
  };

  const taglineStyles = {
    fontFamily: "'Verdana', ui-sans-serif, system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 700,
    fontSize: "0.7rem",
    textTransform: "uppercase",
    color: "#f9a8af",
    display: "block",
    textAlign: "center",
    marginTop: "-8px",
    whiteSpace: "nowrap",
  };

  const ribbonStyles = {
    position: "absolute",
    top: "6px",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: logoTitles.env === "prod" ? "#ff4444" : "#4CAF50",
    color: "#ffffff",
    fontSize: "0.6rem",
    fontWeight: 700,
    padding: "4px 12px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    zIndex: 10,
    boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0 0 6px 6px",
    minWidth: "40px",
    whiteSpace: "nowrap",
  };

  const logoContent = (
    <Box
      ref={ref}
      component="div"
      sx={logoContainerStyles}
      role="img"
      aria-label={`${logoTitles.main} — ${logoTitles.tagline}`}
      {...other}
    >
      <Typography component="div" sx={logoTextStyles}>
        {logoTitles.main}
      </Typography>
      <Typography component="div" sx={taglineStyles}>
        {logoTitles.tagline}
      </Typography>
      <Box component="div" sx={ribbonStyles}>
        {logoTitles.env === "prod" ? "PROD" : "DEV"}
      </Box>
    </Box>
  );

  if (disabledLink) {
    return logoContent;
  }

  return (
    <Link
      to="/"
      component={RouterLink}
      sx={{
        textDecoration: "none",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        "&:hover": {
          textDecoration: "none",
        },
      }}
    >
      {logoContent}
    </Link>
  );
});

export default Logo;
